import { I18nComponente } from "@/types/gerais"

export const MModalSeletorRadioi18n: I18nComponente = {
  "pt-BR": {
    salvar: "salvar",
    deletar: "deletar",
    cancelar: "cancelar"
  },
  "es-CO": {
    salvar: "guardar",
    deletar: "borrar",
    cancelar: "cancelar"
  }
}
